import {BrowserModule} from '@angular/platform-browser';
import {APP_INITIALIZER, ErrorHandler, NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {AppRoutingModule} from '~/app/app-routing.module';
import {AppComponent} from '~/app/app.component';
import {ApptemplateLibModule, ENVIRONMENTERTEMPLATE, LoggingService,
    MCdialogService} from 'mclane-apptemplate-lib';
import {
    AuthGuard,
    AuthInterceptorService,   
    ChallengeModule,
    JwtService,
    MclaneWebauthLibModule,
    OauthService,
    WEBAUTHENVIRONMENTER
} from 'mclane-webauth-lib';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha-2';
import {environment} from '~/environments/environment';
import {KeycloakAngularModule, KeycloakService} from 'keycloak-angular';
import {HomeComponent} from '~/app/web/home/home.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {
    BodyModule,
    ExcelModule,
    FilterMenuModule,
    GridModule,
    PDFModule,
    RowFilterModule,
    SharedModule,
} from '@progress/kendo-angular-grid';
import {ButtonsModule,ButtonModule} from '@progress/kendo-angular-buttons';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {ApiService} from '~/app/core/common/services/api.service';
import {ConfirmComponent} from '~/app/web/confirm/confirm.component';
import {StoreListService} from '~/app/core/common/services/store-list.service';
import {CookieService} from 'ngx-cookie-service';
import {CalendarModule, DateAdapter} from 'angular-calendar';
import {adapterFactory} from 'angular-calendar/date-adapters/date-fns';

import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import {DigitsConstraint} from '~/app/web/digitsConstraint';
import {NgMaterialMultilevelMenuModule} from 'ng-material-multilevel-menu';
import {DropDownsModule} from '@progress/kendo-angular-dropdowns';
import {LayoutModule} from '@progress/kendo-angular-layout';
import {FloatingLabelModule, LabelModule} from "@progress/kendo-angular-label";
import {MatChipsModule} from '@angular/material/chips';
import {CalendarComponent} from '~/app/web/calendar/calendar.component';
import {StorelistDialogComponent} from '~/app/web/components/storelist-dialog/storelist-dialog.component';
import {MenuComponent} from '~/app/web/components/menu/menu.component';
import {MatMenuModule} from '@angular/material/menu';
import {NotificationModule} from '@progress/kendo-angular-notification';
import {ServiceWorkerModule} from '@angular/service-worker';
import {Overlay, OverlayContainer, ToastrModule, ToastrService} from 'ngx-toastr';
import {StoreListComponent} from '~/app/web/store-list/store-list.component';
import {NotificationsComponent} from '~/app/web/components/notifications/notifications.component';
import {MatBadgeModule} from '@angular/material/badge';
import {LoadingbuttonComponent} from '~/app/web/sharedcomponents/loadingbutton/loadingbutton.component';
import {SharedcomponentsModule} from '~/app/web/sharedcomponents/sharedcomponents.module';
import {ProfileComponent} from '~/app/web/profile/profile.component';
import {COMPONENT_DECLARATIONS, SHARED_MODULES} from '~/app/app.common';
import {OrderReviewComponent} from '~/app/web/reports/order-review/order-review.component';
import {ReportService} from '~/app/core/common/services/report.service';
import {InputsModule, TextBoxModule} from '@progress/kendo-angular-inputs';
import {ProfileItemsComponent} from '~/app/web/profile-items/profile-items.component';
import {ProfileCategoriesComponent} from '~/app/shared/profile-categories/profile-categories.component';
import {ErrorApiService} from '~/app/core/common/test/error-api.service';
import {CanDeactivateGuard} from '~/app/shared/navigation/can-deactivate.guard';
import {CategoriesComponent} from '~/app/web/components/categories/categories.component';
import {OrderingComponent} from '~/app/web/ordering/ordering.component';
import {InventoryComponent} from '~/app/shared/inventory/inventory.component';
import {InventoryReceivingAddComponent} from '~/app/shared/inventory-receiving-add/inventory-receiving-add.component';
import {PartialdialogComponent} from '~/app/web/components/partialdialog/partialdialog.component';
import {GoogleAnalyticsService} from '~/app/core/common/services/google-analytics.service';
import {AddItemsDialogComponent} from '~/app/web/components/add-items-dialog/add-items-dialog.component';
import {InternetConnectionService} from '~/app/shared/services/internet-connection.service';
import {DialogModule, DialogsModule} from '@progress/kendo-angular-dialog';
import {DialogContentComponent} from '~/app/web/components/dialog-content/dialog-content.component';
import {WarningDialogContentComponent} from '~/app/web/components/warning-dialog-content/warning-dialog-content.component';
import {SettingsComponent} from '~/app/shared/settings/settings.component';
import {EnvironmentChangeDialogComponent} from '~/app/web/components/environment-change-dialog/environment-change-dialog.component';
import {ConfigurationService} from '~/app/core/common/services/configuration.service';
import {MogComponent} from '~/app/web/mog/mog.component';
import {AuthGuardService} from '~/app/shared/navigation/auth-guard.service';
import {RoleGuardService} from '~/app/shared/navigation/role-guard.service';
import {NotFoundComponent} from '~/app/shared/not-found/not-found.component';
import {NoAccessComponent} from '~/app/shared/not-found/no-access.component';
import {Error500Component} from '~/app/shared/not-found/error-500.component';
import {NoStoresComponent} from '~/app/shared/not-found/no-stores.component';
import {RECAPTCHA_V3_SITE_KEY, ReCaptchaV3Service} from 'ng-recaptcha-2';
import {NoStoresDialogComponent} from '~/app/shared/no-stores-dialog/no-stores-dialog.component';
import {TooltipModule} from '@progress/kendo-angular-tooltip';
import {InCellTabDirective} from '~/app/web/ordering/incelltab.directive';
import {PDFExportModule} from '@progress/kendo-angular-pdf-export';
import {NewItemComponent} from '~/app/web/reports/new-item/new-item.component';
import {DatePipe} from '@angular/common';
import {ReportCommonComponent} from '~/app/web/reports/report-common/report-common.component';
import {ExcelExportModule} from '@progress/kendo-angular-excel-export';
import {OrderUploadComponent} from '~/app/web/order-upload/order-upload.component';
import {OrderUploadReviewComponent} from '~/app/web/order-upload-review/order-upload-review.component';
import {OrderUploadMessageComponent} from '~/app/order-upload-message/order-upload-message.component';
import {DirectAccessGuard} from "~/app/shared/navigation/direct-access.guard";
import {InvoicelistDialogComponent} from "~/app/web/components/invoicelist-dialog/invoicelist-dialog.component";
import { GlobalErrorHandlerService } from './shared/services/globalErrorHandlerService';
import { OrderguideWorksheetComponent } from './web/reports/orderguide-worksheet/orderguide-worksheet.component';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {  ICON_SETTINGS, IconsModule } from "@progress/kendo-angular-icons";
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
declare let gtag: Function;
export function 
AuthFactory(keycloakService: KeycloakService,
                           configurationService:ConfigurationService,
                           jwtService: JwtService,
                           console:LoggingService ) {
    
        return (): Promise<any> => {
            configurationService.setApiModeWeb();
            return new Promise((resolve, reject) => {
                keycloakService.init({
                config: environment.keycloak,
                initOptions: {checkLoginIframe: false, onLoad: 'login-required'},
                loadUserProfileAtStartUp: true
            }).then(async () => {
                await keycloakService.getToken().then(async (token) => {
                    jwtService.setJwt(token);
                    gtag('set', {'user_id': jwtService.preferred_username});
                    console.log('preferred username= ', jwtService.preferred_username);
                    console.log('roles= ', jwtService.roles);
                   resolve(true);
 
                });
            });
        });
    };
}

@NgModule({ declarations: [
        AppComponent,
        HomeComponent,
        ConfirmComponent,
        DigitsConstraint,
        CalendarComponent,
        StorelistDialogComponent,
        InvoicelistDialogComponent,
        MenuComponent,
        NotificationsComponent,
        ProfileItemsComponent,
        ProfileComponent,
        ProfileCategoriesComponent,
        InventoryComponent,
        InventoryReceivingAddComponent,
        OrderReviewComponent,
        CategoriesComponent,
        PartialdialogComponent,
        OrderingComponent,
        AddItemsDialogComponent,
        StoreListComponent,
        DialogContentComponent,
        WarningDialogContentComponent,
        NoStoresDialogComponent,
        EnvironmentChangeDialogComponent,
        SettingsComponent,
        NoStoresComponent,
        NoAccessComponent,
        NotFoundComponent,
        Error500Component,
        ...COMPONENT_DECLARATIONS,
        MogComponent,
        NoStoresDialogComponent,
        InCellTabDirective,
        NewItemComponent,
        ReportCommonComponent,
        OrderUploadComponent,
        OrderUploadReviewComponent,
        OrderUploadMessageComponent,
        OrderguideWorksheetComponent,
    ],
    exports: [
        LoadingbuttonComponent
    ],
    schemas: [
        NO_ERRORS_SCHEMA
    ],
    bootstrap: [AppComponent], imports: [DialogsModule,
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        KeycloakAngularModule,
        BrowserAnimationsModule,
        InputsModule,
        GridModule,
        ButtonsModule,
        NgMaterialMultilevelMenuModule,
        CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory
        }),
        MatSidenavModule,
        DropDownsModule,
        MatIconModule,
        MatTooltipModule,
        LayoutModule,
        MatChipsModule,
        MatDialogModule,
        MatButtonModule,
        MatBadgeModule,
        MatMenuModule,
        NotificationModule,
        BrowserAnimationsModule,
        IconsModule,
        ToastrModule.forRoot({
            timeOut: 5000,
            autoDismiss: true,
            maxOpened: 5,
            positionClass: 'toast-bottom-right',
            progressAnimation: 'decreasing',
            progressBar: true
        }),
        BodyModule,
        SharedModule,
        SharedcomponentsModule,
        ...SHARED_MODULES,
        TextBoxModule,
        LabelModule,
        FloatingLabelModule,
        MatProgressBarModule,
        FilterMenuModule,
        RowFilterModule,
        RouterModule,
        MatTabsModule,
        DialogModule,
        DateInputsModule,
        ApptemplateLibModule,
        MclaneWebauthLibModule,
        ChallengeModule,
        TooltipModule,
        PDFExportModule,
        PDFModule,
        ExcelExportModule,
        ExcelModule,
        RecaptchaModule,
        RecaptchaFormsModule], providers: [
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true },
        // {provide: HTTP_INTERCEPTORS, useClass: RetryInterceptorService, multi: true},
        { provide: ENVIRONMENTERTEMPLATE, useValue: environment },
        { provide: RECAPTCHA_V3_SITE_KEY, useValue: '6Lchb6MZAAAAAKm5BjabNHPTJDq9CorYDIBYkgyW' },
        {
            provide: APP_INITIALIZER,
            useFactory: AuthFactory,
            multi: true,
            deps: [KeycloakService, ConfigurationService, JwtService, LoggingService]
        },
        { provide: WEBAUTHENVIRONMENTER, useValue: environment },
        StoreListService,
        InternetConnectionService,
        ApiService,
        ErrorApiService,
        CookieService,
        ReportService,
        CanDeactivateGuard,
        DirectAccessGuard,
        GoogleAnalyticsService,
        AuthGuardService,
        RoleGuardService,
        JwtService,
        OauthService,
        ReCaptchaV3Service,
        ToastrService,
        Overlay,
        OverlayContainer,
        DatePipe,
        { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
        { provide: ICON_SETTINGS, useValue: { type: 'svg' } },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {
}
